"use client";

import Link from "next/link";
import { useState } from "react";
import { useRouter } from "next/navigation";

export default function LoginPage() {
  const router = useRouter();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      // 1. Obtener Token JWT
      const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/token/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      if (!res.ok) {
        throw new Error("Credenciales inválidas");
      }

      const data = await res.json();
      const token = data.access;
      localStorage.setItem("token", token);

      // 2. Obtener Perfil para saber el Rol
      const profileRes = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/me/`, {
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });
      
      const profile = await profileRes.json();
      localStorage.setItem("user", JSON.stringify(profile));

      // 3. Redirigir según el Rol
      if (profile.role === "DOCTOR") {
        router.push("/dashboard/doctor");
      } else if (profile.role === "PATIENT") {
        router.push("/dashboard/patient");
      } else if (profile.role === "ADMIN") {
        router.push("/dashboard/admin");
      } else {
        router.push("/dashboard/secretary");
      }

    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col justify-center items-center p-6 relative overflow-hidden">
      {/* Background gradients */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>

      <div className="w-full max-w-md bg-white dark:bg-slate-900 rounded-3xl shadow-xl border border-slate-200 dark:border-slate-800 p-8 relative z-10">
        <div className="text-center mb-8">
          <Link href="/" className="text-2xl font-bold text-primary tracking-tight">
            Doctor<span className="text-slate-800 dark:text-white">Online</span>
          </Link>
          <span className="text-[10px] text-slate-400 block mt-1">v2.0 (Auto-Deploy Configured)</span>
          <h2 className="text-xl font-semibold mt-6 text-slate-800 dark:text-white">
            Iniciar Sesión
          </h2>
          <p className="text-slate-500 text-sm mt-2">
            Ingresá tus credenciales para continuar
          </p>
        </div>

        {error && (
          <div className="bg-red-100 text-red-600 p-3 rounded-lg mb-4 text-sm text-center">
            {error}
          </div>
        )}

        <form className="space-y-5" onSubmit={handleLogin}>
          <div>
            <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Usuario (Email o DNI)</label>
            <input 
              type="text" 
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-3 rounded-xl border border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-slate-100 focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all" 
              placeholder="Ej: paciente_test" 
              required
            />
          </div>

          <div>
            <div className="flex justify-between items-center mb-1">
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300">Contraseña</label>
            </div>
            <input 
              type="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-xl border border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-slate-100 focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all" 
              placeholder="••••••••" 
              required
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            className="w-full bg-primary text-primary-foreground py-3.5 rounded-xl font-bold text-lg shadow-lg shadow-blue-500/30 hover:bg-blue-700 transition-all mt-4 disabled:opacity-50"
          >
            {loading ? "Ingresando..." : "Ingresar"}
          </button>
        </form>

        <p className="text-center text-sm text-slate-500 mt-8">
          ¿No tenés cuenta? <Link href="/register" className="text-primary font-semibold hover:underline">Registrate gratis</Link>
        </p>
      </div>
    </div>
  );
}
